import { createAction } from "@reduxjs/toolkit";
import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import { amRoutes, externalLinks, ucEndpoints } from "../../config/config";
import { delayBeforeRedirect } from "../../config/constants";
import { showSuccessMessage } from "../../store/statusMessages";
import { getErrorMessageFromRequest } from "../../utils/utils";
import { apiCallBegan } from "../middlwares/api";
import { setShortToken } from "../users/users";
import * as actionTypes from "./actionTypes";

export const setInvitationToken = createAction(actionTypes.SET_INVITATION_TOKEN);
export const checkInvitationTokenStart = createAction(actionTypes.INVITATION_TOKEN_CHECK_START);
export const checkInvitationTokenSuccess = createAction(actionTypes.INVITATION_TOKEN_CHECK_SUCCESS);
export const checkInvitationTokenFailure = createAction(actionTypes.INVITATION_TOKEN_CHECK_FAILURE);
export const userInviteConfirmStart = createAction(actionTypes.USER_INVITE_CONFIRM_START);
export const userInviteConfirmSuccess = createAction(actionTypes.USER_INVITE_CONFIRM_SUCCESS);
export const userInviteConfirmFailure = createAction(actionTypes.USER_INVITE_CONFIRM_FAILURE);

export const checkInvitationToken = invitationToken => dispatch => {
  dispatch(setInvitationToken(invitationToken));
  dispatch(
    apiCallBegan({
      url: ucEndpoints.checkInvitation,
      method: "post",
      data: { invitationToken },
      onStart: checkInvitationTokenStart,
      onSuccess: ({ invitation, shortToken }) => dispatch => {
        dispatch(checkInvitationTokenSuccess({ invitation }));
        setShortToken(shortToken);
      },
      onFailure: error => dispatch => {
        let message;
        switch (error.response.status) {
          case 400: // Invitation already accepted
            message = (
              <>
                You have already confirmed your account. Click
                <Link to={amRoutes.login}> here</Link>, to login.
              </>
            );
            break;
          case 401:
            {
              // Invitation expired
              const expiredAt = moment(error.response.data.expiredAt);
              message = `Your invitation expired on ${expiredAt.format(
                "MMM D YYYY, h:mm A"
              )}.\nPlease contact the administrator who invited you to request a new invitation.`;
            }
            break;
          default:
            message = "Your account invitation is no longer valid.";
            message +=
              "\nPlease contact the administrator who invited you to request a new invitation.";
            break;
        }
        dispatch(checkInvitationTokenFailure(message));
      }
    })
  );
};

export const acceptInvitation = values => dispatch =>
  dispatch(
    apiCallBegan({
      url: ucEndpoints.acceptInvitation,
      method: "post",
      data: values,
      onStart: () => dispatch => dispatch(userInviteConfirmStart()),
      onSuccess: ({ system }) => dispatch => {
        dispatch(userInviteConfirmSuccess());
        dispatch(showSuccessMessage("Invitation accepted!"));
        return setTimeout(() => {
          window.location.href = externalLinks[system];
        }, delayBeforeRedirect);
      },
      onFailure: error => dispatch =>
        dispatch(userInviteConfirmFailure(getErrorMessageFromRequest(error)))
    })
  );
